package pl.nickers.match3.ui

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.layout.LayoutCoordinates

/** Shared layout anchors for power-up and goal flight animations (window-consistent positioning). */
internal class FlightAnchorRegistry {
    var root: LayoutCoordinates? by mutableStateOf(null)
    var grid: LayoutCoordinates? by mutableStateOf(null)
    var familiar: LayoutCoordinates? by mutableStateOf(null)
    val bombButtons = mutableStateMapOf<Int, LayoutCoordinates>()
    val goalIcons = mutableStateMapOf<String, LayoutCoordinates>()
}
